<template>
    <confirm-dialog
        v-on:confirm="removeStudentFromGroup"
        v-on:cancel=""
        confirm-button-label="Yes, remove student"
        cancel-button-label="Cancel"
    >
        <template #trigger>
            <div
                class="px-4 py-2 text-red-500 hover:cursor-pointer hover:bg-gray-200"
            >
                Remove student
            </div>
        </template>
        <template #content>
            <div class="flex flex-col gap-4">
                <div class="">
                    Removing a student will remove them from your organization.
                    They will retain any remaining membership time.
                </div>
                <div class="font-semibold">Are you sure?</div>
            </div>
        </template>
    </confirm-dialog>
</template>
<script>
import ConfirmDialog from "@/Components/ConfirmDialog";

export default {
    name: "GroupRemoveStudentButton",
    components: { ConfirmDialog },
    props: {
        student: {},
    },
    methods: {
        removeStudentFromGroup() {
            this.$inertia.get(
                route("group.student.remove-from-group", {
                    user: this.student.id,
                })
            );
        },
    },
};
</script>
